import {
  EntityAboutCard,
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityLayout,
  EntityLinksCard,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  EntitySwitch,
  hasCatalogProcessingErrors,
  isOrphan,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import {
  EntityGithubActionsContent,
  isGithubActionsAvailable,
} from '@backstage-community/plugin-github-actions';

import {
  EntityAdrContent,
  isAdrAvailable,
} from '@backstage-community/plugin-adr';
import { EntityTodoContent } from '@backstage-community/plugin-todo';
import {
  EntityConsumedApisCard,
  EntityProvidedApisCard,
} from '@backstage/plugin-api-docs';
import {
  EntityTechdocsContent,
  isTechDocsAvailable,
} from '@backstage/plugin-techdocs';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { CoderWorkspacesCard } from '@coder/backstage-plugin-coder';
import { default as Grid } from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import { CoderWorkspaceCardHeader } from '../../coder';
import {
  isApiAvailable,
  isCoderAvailable,
  isDependenciesAvailable,
  isLinksAvailable,
} from '../util';

export const FixedHeightGrid = styled(Grid)({
  '& > div': {
    height: '100%',
  },
});

export const ScrollingFixedHeightGrid = styled(FixedHeightGrid)({
  '& > div': {
    height: '100%',
    overflow: 'auto',
    maxHeight: '40rem',
  },
});

const techdocsContent = (
  <EntityTechdocsContent>
    <TechDocsAddons>
      <ReportIssue />
    </TechDocsAddons>
  </EntityTechdocsContent>
);

export const entityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid>
          <EntityOrphanWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid>
          <EntityProcessingErrorsPanel />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

export const commonOverviewContent = (
  <Grid container spacing={3} size={12} alignItems="stretch">
    {entityWarningContent}

    <Grid size={6}>
      <EntitySwitch>
        <EntitySwitch.Case if={isLinksAvailable}>
          <Grid
            container
            gap={3}
            size={12}
            justifyContent="space-between"
            direction="column"
            height="100%"
          >
            <EntityAboutCard />

            <EntityLinksCard />
          </Grid>
        </EntitySwitch.Case>

        <EntitySwitch.Case>
          <EntityAboutCard />
        </EntitySwitch.Case>
      </EntitySwitch>
    </Grid>

    <Grid size={6}>
      <EntityCatalogGraphCard height={400} />
    </Grid>

    <EntitySwitch>
      <EntitySwitch.Case if={isCoderAvailable}>
        <FixedHeightGrid size={6}>
          <CoderWorkspacesCard
            readEntityData
            headerContent={<CoderWorkspaceCardHeader />}
          />
        </FixedHeightGrid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </Grid>
);

export const commonRoutes = [
  <EntityLayout.Route if={isTechDocsAvailable} path="/docs" title="Docs">
    {techdocsContent}
  </EntityLayout.Route>,

  <EntityLayout.Route path="/api" title="API" if={isApiAvailable}>
    <Grid container spacing={3} size={12} alignItems="stretch">
      <Grid>
        <EntityProvidedApisCard />
      </Grid>
      <Grid>
        <EntityConsumedApisCard />
      </Grid>
    </Grid>
  </EntityLayout.Route>,

  <EntityLayout.Route
    if={isDependenciesAvailable}
    path="/dependencies"
    title="Dependencies"
  >
    <Grid container spacing={3} size={12} alignItems="stretch">
      <Grid>
        <EntityDependsOnComponentsCard />
      </Grid>
      <Grid>
        <EntityDependsOnResourcesCard />
      </Grid>
    </Grid>
  </EntityLayout.Route>,

  <EntityLayout.Route if={isAdrAvailable} path="/adrs" title="ADRs">
    <EntityAdrContent />
  </EntityLayout.Route>,

  <EntityLayout.Route path="/todo" title="Todo">
    <EntityTodoContent />
  </EntityLayout.Route>,

  <EntityLayout.Route
    if={isGithubActionsAvailable}
    path="/github-actions"
    title="GitHub Actions"
  >
    <EntityGithubActionsContent />
  </EntityLayout.Route>,
];
